const commandModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/conditions/condition-form/trigger-form/command-modal/command-modal.html',
  controller: 'CommandModalController',
};

angular
  .module('pis-tool.module')
  .component('commandModal', commandModal);
